// client/src/pages/LoginPage.js
import React, { useState, useContext } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { TextField, Button, Alert, Stack, InputAdornment, IconButton } from '@mui/material';
import AuthLayout from '../components/AuthLayout';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { AuthContext } from '../context/AuthContext';
import { useStore } from '../context/StoreContext';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect');
  const { login } = useContext(AuthContext);
  const { store } = useStore();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate(redirect || '/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      eyebrow="Welcome back"
      title={`Sign in to ${store.name}`}
      footer={(
        <>
          New here?{' '}
          <Link to={`/register${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''}`} style={{ color: 'inherit', fontWeight: 700 }}>
            Create an account
          </Link>
        </>
      )}
    >
          <Stack component="form" onSubmit={handleSubmit} spacing={2.25}>
            {error && <Alert severity="error">{error}</Alert>}
            <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required fullWidth autoComplete="email" />
            <TextField
              label="Password" type={showPassword ? 'text' : 'password'} value={password}
              onChange={(e) => setPassword(e.target.value)} required fullWidth autoComplete="current-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword((v) => !v)} edge="end" aria-label="Toggle password visibility">
                      {showPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button type="submit" variant="contained" size="large" disabled={loading} sx={{ py: 1.5, fontWeight: 700 }}>
              {loading ? 'Signing in…' : 'Sign in'}
            </Button>
            <Link to="/forgot-password" style={{ color: 'inherit', fontSize: '0.875rem', textAlign: 'center' }}>Forgot your password?</Link>
          </Stack>
    </AuthLayout>
  );
};

export default LoginPage;
